import { NgModule } from '@angular/core';

import { HideOnBreakpointDirective } from './hide-on-breakpoint.directive';

@NgModule({
    exports: [HideOnBreakpointDirective],
    declarations: [HideOnBreakpointDirective],
})
export class HideOnBreakpointModule { }
